
import { defineComponent } from 'vue'
import ActiveUserMixin from '~/mixins/activeUserMixin'
import AutoOnboardMixin from '~/mixins/autoOnboardMixin'
import { ConfigTemplate } from '~/types/types'
import { resolveNodes } from '~/utils/array'

export default defineComponent({
  name: 'SelectTemplate',
  mixins: [ActiveUserMixin, AutoOnboardMixin],
  data() {
    return {
      currentTemplateList: [] as ConfigTemplate[],
      searchCandidate: ''
    }
  },
  async fetch() {
    await this.fetchTemplates()
  },
  computed: {
    settingsLink(): string {
      return ['', 'orgs', this.activeProvider, this.activeOwner, 'settings', 'auto-onboard'].join(
        '/'
      )
    },
    onAutoOnboardPage(): boolean {
      return this.$route.path === this.settingsLink
    }
  },
  methods: {
    async fetchTemplates() {
      const connection = await this.fetchConfigTemplatesList({
        login: this.activeOwner,
        provider: this.activeProvider,
        limit: 25,
        q: this.searchCandidate,
        currentPage: 1,
        refetch: true
      })

      this.currentTemplateList = resolveNodes(connection)
    },
    optionallyCloseModal() {
      if (this.onAutoOnboardPage) this.$emit('close')
    }
  }
})
